// extracted by mini-css-extract-plugin
module.exports = {"root":"UVChildItemNotificationSelector_root__3WG-1"};